import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Iframe from 'react-iframe';
import ConfirmDialog from './ConfirmDialog';
import Button from './Button';


class ConditionsAndPolicyLinks extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            dialogTitle: '',
            dialogUrl: undefined,
            dialogText: undefined,
            dialogOpened: false,
            dialogConfirm: undefined,
            dialogSize: 'fullscreen',
        };
    }

    open(title, url) {
        if (this.props.openExternally) {
            window.open(url);
            return;
        }

        this.setState({
            dialogTitle: title,
            dialogUrl: url,
            dialogOpened: true,
        });
    }

    render() {
        return (
            <div className="policy-links">
            <Button onClick={() => this.open('Privacy Policy', '/html/privacy_policy.html')}
                    bsStyle='link'
                    disabled={!!this.props.disabled}
                    label="Privacy Policy"/>
            <span className="policy-links__dot" aria-hidden="true">&middot;</span>
            <Button onClick={() => this.open('Terms and Conditions', '/html/client_agreement.html')}
                    bsStyle='link'
                    disabled={!!this.props.disabled}
                    label="Terms and Conditions"/>
            <ConfirmDialog title={this.state.dialogTitle}
                           text={this.state.dialogText}
                           cancel={() => {this.setState({dialogOpened: false})}}
                           confirm={this.state.dialogConfirm}
                           size={this.state.dialogSize}
                           open={this.state.dialogOpened}>
                           {this.state.dialogUrl && (
                            <div className="policy-frame">
                            <Iframe url={this.state.dialogUrl}
                                    width="100%"
                                    height="100%"
                                    display="initial"
                                    position="relative" />
                            </div>)}
              </ConfirmDialog>
            </div>
        );
    }
}

ConditionsAndPolicyLinks.propTypes = {
    disabled: PropTypes.boolean,
    openExternally: PropTypes.boolean,
};

export default ConditionsAndPolicyLinks;

